// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file nodebase/v1/account.proto (package nodebase.v1, syntax proto3)
/* eslint-disable */

import { AccountService } from "./account_pb";

/**
 * BeginLogin is the first step of a product sign-in: given an address, it
 * says which second step follows and, when that step is the emailed code,
 * sends the code in the same call. Accounts an operator set a password on
 * (control-api set-password) get LOGIN_METHOD_PASSWORD and no email; every
 * other address — registered or not — gets LOGIN_METHOD_CODE and a code,
 * exactly as RequestLoginCode would, so this is no more of an
 * account-existence oracle than that call is. What it does disclose is which
 * addresses carry an operator password: those are the operator's own
 * accounts, and guessing their passwords is bounded by LoginWithPassword's
 * lockout, not by keeping the method secret. It exists because a person who
 * cannot receive email (an app reviewer, a device lane) should never be shown
 * a code screen and left to discover the password path.
 *
 * @generated from rpc nodebase.v1.AccountService.BeginLogin
 */
export const beginLogin = AccountService.method.beginLogin;

/**
 * @generated from rpc nodebase.v1.AccountService.RequestLoginCode
 */
export const requestLoginCode = AccountService.method.requestLoginCode;

/**
 * @generated from rpc nodebase.v1.AccountService.VerifyLoginCode
 */
export const verifyLoginCode = AccountService.method.verifyLoginCode;

/**
 * GetRegistrationOptions is the public, server-owned description of the
 * Worker locations currently open to invited registrations. A region that
 * has no real provisioning capacity must not be returned here.
 *
 * @generated from rpc nodebase.v1.AccountService.GetRegistrationOptions
 */
export const getRegistrationOptions = AccountService.method.getRegistrationOptions;

/**
 * RegisterWithLoginCode is the only account-creation RPC. Product clients
 * use VerifyLoginCode for existing accounts; the Web onboarding flow uses
 * this explicit invite + location transaction for a new account.
 *
 * @generated from rpc nodebase.v1.AccountService.RegisterWithLoginCode
 */
export const registerWithLoginCode = AccountService.method.registerWithLoginCode;

/**
 * LoginWithPassword serves the accounts an operator has set a password for
 * (control-api set-password) — chiefly operator accounts whose mailbox
 * cannot receive a code. The emailed code stays the product login; an
 * account without a stored password cannot use this.
 *
 * @generated from rpc nodebase.v1.AccountService.LoginWithPassword
 */
export const loginWithPassword = AccountService.method.loginWithPassword;

/**
 * @generated from rpc nodebase.v1.AccountService.RefreshSession
 */
export const refreshSession = AccountService.method.refreshSession;

/**
 * Logout revokes the session that owns the presented refresh token.
 * Possession of the refresh token is the authorization — no access token is
 * required, so a client whose access token has already expired can still end
 * its session. Revoking an unknown token succeeds: the caller's goal (that
 * session no longer works) is already true.
 *
 * @generated from rpc nodebase.v1.AccountService.Logout
 */
export const logout = AccountService.method.logout;

/**
 * RequestAccountDeletionCode emails a short-lived code to the authenticated
 * account. DeleteAccount will not accept a login code or a code issued for
 * another account.
 *
 * @generated from rpc nodebase.v1.AccountService.RequestAccountDeletionCode
 */
export const requestAccountDeletionCode = AccountService.method.requestAccountDeletionCode;

/**
 * DeleteAccount permanently removes the authenticated account and its
 * Workspace data. It requires the deliberate acknowledgement; the emailed
 * deletion code is optional (App Store guideline 5.1.1(v): deletion must be
 * completable in the app without extra steps) and is checked when sent. The
 * access session is revoked only after every external cleanup succeeds, so a
 * partial failure remains retryable.
 *
 * @generated from rpc nodebase.v1.AccountService.DeleteAccount
 */
export const deleteAccount = AccountService.method.deleteAccount;

/**
 * Browser sign-in, in the shape of the OAuth 2.0 device authorization grant
 * (RFC 8628). A Desktop app, CLI or router cannot host a Web login itself,
 * so it asks for a pair of codes, sends the person to the Web page that
 * signs in or registers them, and waits. The device code is the device's
 * secret; the user code is what the person checks on the page.
 *
 * StartDeviceLogin is unauthenticated (it is how a device obtains an
 * identity) and rate-limited per source. The device-reported name and
 * platform are shown on the approval page, so a person can tell a request
 * they started from one somebody else is trying to get them to approve.
 *
 * @generated from rpc nodebase.v1.AccountService.StartDeviceLogin
 */
export const startDeviceLogin = AccountService.method.startDeviceLogin;

/**
 * PollDeviceLogin is the device's wait. Unauthenticated: possession of the
 * device code is the authorization. An approval is redeemed exactly once —
 * the poll that returns the session also spends the device code. A device
 * that polls faster than the interval is told DEVICE_LOGIN_STATUS_SLOW_DOWN
 * and given a longer interval.
 *
 * @generated from rpc nodebase.v1.AccountService.PollDeviceLogin
 */
export const pollDeviceLogin = AccountService.method.pollDeviceLogin;

/**
 * GetDeviceLogin is the approval page's read: what is asking, from where.
 * It needs the signed-in account session of the person approving.
 *
 * @generated from rpc nodebase.v1.AccountService.GetDeviceLogin
 */
export const getDeviceLogin = AccountService.method.getDeviceLogin;

/**
 * DecideDeviceLogin approves or denies a pending request for the caller's
 * account. Single use: a code that was already decided, or has expired, is
 * refused the same way as one that never existed.
 *
 * @generated from rpc nodebase.v1.AccountService.DecideDeviceLogin
 */
export const decideDeviceLogin = AccountService.method.decideDeviceLogin;
